import { render, staticRenderFns } from "./UploadResult.vue?vue&type=template&id=48bbfdc1&scoped=true"
import script from "./UploadResult.ts?vue&type=script&lang=ts&external"
export * from "./UploadResult.ts?vue&type=script&lang=ts&external"
import style0 from "./UploadResult.vue?vue&type=style&index=0&id=48bbfdc1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bbfdc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48bbfdc1')) {
      api.createRecord('48bbfdc1', component.options)
    } else {
      api.reload('48bbfdc1', component.options)
    }
    module.hot.accept("./UploadResult.vue?vue&type=template&id=48bbfdc1&scoped=true", function () {
      api.rerender('48bbfdc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/NoContract/components/UploadResult/UploadResult.vue"
export default component.exports